import { useActiveStore } from '@/store/activePages';

// Components
import Tab from '@/components/Tab';
import Tabs from '@/components/Tabs';
import useBreakpoint from '@/hooks/useBreakpoint';
import useVerifySMSConfirmationIsOn from '@/hooks/useVerifySMSConfimationIsOn/useVerifySMSConfimationIsOn';
import { useFormStore } from '@/store/form';

// Wizard Tabs
const WizardTabs = () => {
  const activePages = useActiveStore((store) => store.pages);
  const isPortability = useFormStore((store) => store.isPortability);
  const isMigration = useFormStore((store) => store.isMigration);
  const ddd = useFormStore((store) => store.value.tel).slice(0, 2);
  const smsFromPortabilityIsOn = useVerifySMSConfirmationIsOn(
    ddd,
    isPortability(),
  );
  const { isOnBreakpoint: isTableOrLess } = useBreakpoint(1024);

  const defaultTabsData = [
    {
      name: isTableOrLess ? 'você' : 'sobre você',
      id: 'personal-data',
    },
    {
      name: 'produto',
      id: 'type-product',
    },
    {
      name: 'endereço',
      id: 'address-info',
    },
    {
      name: 'pagamento',
      id: 'payment-data',
    },
    {
      name: 'validação',
      id: 'payment-data/sms',
    },
  ];

  const validationStepIsOn = isMigration() ? true : smsFromPortabilityIsOn;
  const tabsData = validationStepIsOn
    ? defaultTabsData
    : defaultTabsData.filter((tab) => tab.id !== 'payment-data/sms');
  return (
    <Tabs className='px-4 pt-4 pb-2 lg:mt-0 lg:px-10 lg:pb-4 lg:pt-6'>
      {tabsData.map((tab) => {
        const status = activePages.has(`/${tab.id}`) ? 'active' : 'disabled';

        return <Tab key={tab.id} name={tab.name} status={status} />;
      })}
    </Tabs>
  );
};

export default WizardTabs;
